import ListingPage from '../../components/ListingPage';
import ViberMessagesCards from '../../components/ViberMessages/ViberMessagesCards';

const ViberMessagesPage = () => {
  return (
    <ListingPage
      createRestrictionKey="viberMessagesCreate"
      entityType="viberMessage"
      useStats={true}
      filterBy="name"
      Cards={ViberMessagesCards}
    />
  );
};

export default ViberMessagesPage;
